import { type StateCreator } from 'zustand';

export type WorkspaceRightPanelFullscreenSlice = {
  isFullscreen: boolean;
  toggleFullscreen: () => void;
  openFullscreen: () => void;
  closeFullscreen: () => void;
  /** Exit fullscreen but keep the right panel open */
  exitFullscreen: () => void;
  /** Set fullscreen state (used for URL sync) */
  setFullscreen: (value: boolean) => void;
};

export type CreateWorkspaceRightPanelFullscreenSlice = () => StateCreator<
  WorkspaceRightPanelFullscreenSlice,
  [],
  [],
  WorkspaceRightPanelFullscreenSlice
>;

export const createWorkspaceRightPanelFullscreenSlice: CreateWorkspaceRightPanelFullscreenSlice = () => (set) => ({
  isFullscreen: false,
  toggleFullscreen: () => set((state) => ({ isFullscreen: !state.isFullscreen })),
  openFullscreen: () => set({ isFullscreen: true }),
  closeFullscreen: () => set({ isFullscreen: false }),
  exitFullscreen: () => set({ isFullscreen: false }),
  setFullscreen: (value: boolean) => set({ isFullscreen: value }),
});
